var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"placeholder placeholder_overview-table-cell",style:({ width: ((_vm.props.width) + "px"), height: ((_vm.props.height) + "px") })})}
var staticRenderFns = []

export { render, staticRenderFns }